import React from 'react';
import {connect} from 'react-redux';
import Header from '../../../header';
import GuidedToursListPopup from '../../../popup/components/guided-tours-list-popup';
import SupportDetailsPopup from '../../../popup/components/support-details-popup';
import Content from '../../../content';
import Dashboard from '../../../../screens/dashboard';
import {Redirect, Route, Switch, withRouter} from 'react-router-dom';
import Sharing from '../../../../screens/sharing';
import {isAnsweredChromeExtInstallRequest, sharingPageReady} from '../../../../../actions/profileActions';
import TutorialPopup from '../../../popup/components/tutorial-popup';
import VideoPopup from '../../../popup/components/video-popup';
import ConfirmFreeLicensesPopup from '../../../popup/components/confirm-free-licenses-popup';
import MyProfile from '../../../../screens/my-profile';
import {I18nextProvider} from 'react-i18next';
import i18n from '../../../../../i18n';
import TimedOutPage from './components/timed-out-page';
import UninstalledPaidPopup from '../../../popup/components/uninstalled-paid-popup';
import APIKey from '../../../../screens/api-key';
import UpgradeToBusinessPopup from '../../../popup/components/upgrade-to-business-popup';
import ReviewDeletedContacts from '../../../../screens/review-deleted-contacts';
import GrantAccessTemplate from '../grant-access-template';
import CustomFieldsManager from '../../../../screens/dashboard/screens/custom-fields-manager';
import Menu from '../../../menu';
import FreeLicensesErrorPopup from "../../../popup/components/free-licenses-error-popup";
import UserListAddCollaboratorsPopup from "../../../popup/components/user-list-add-collaborators-popup";
import OrgUnitAccessPopup from '../../../popup/components/org-unit-access-popup';
import {fetchCustomFields, fetchCustomFieldsForContactForm} from '../../../../../actions/customFieldsActions';
import DirectoryV5AccessPopup from '../../../popup/components/directory-v5-access-popup';
import Support from "../../../../screens/support";
import RecordingConfirmPopup from '../../../popup/components/recording-confirm-popup';
import ContactWithAiPopup from '../../../popup/components/contact-with-ai-popup';
import ConfirmSwitchToFreePopup from '../../../popup/components/confirm-switch-to-free-popup';
import FreeEditionLabelContactLimitReachedPopup
	from "../../../popup/components/free-edition-label-contact-limit-reached-popup";

class RegisteredGrantedTemplate extends React.Component {

	componentDidMount() {
		if(this.props.profile.role === "ADMINISTRATOR"){
			this.props.fetchCustomFields();
		}

		this.props.fetchCustomFieldsForContactForm();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (localStorage.getItem('chromeExtensionUser')) {
			if (this.props.profile.status === 'registeredGranted') {
				localStorage.removeItem('chromeExtensionUser');
				window.location.href = 'https://contacts.google.com?authuser=' + this.props.profile.email;
			}
		}
	};

	render() {

		const displayTutorial = () => {
			if (
				!localStorage.getItem('isTutorialVideoViewed')
				&& !this.props.isLabelsLoading
				&& this.props.tutorialPopup
				&& this.props.sharingDetailsPopup.length === 0
			) {
				if (this.props.hasCollaboratorsPending) {
					return <TutorialPopup warning={true}/>
				} else {
					return <TutorialPopup />
				}
			} else if (
				!localStorage.getItem('isPendingInvitationTutorialVideoViewed')
				&& this.props.hasCollaboratorsPending
				&& !this.props.isLabelsLoading
				&& this.props.tutorialPopup
				&& this.props.sharingDetailsPopup.length === 0
			) {
				return <TutorialPopup warning={true}/>
			} else {
				return null;
			}
		};

		if (
			this.props.profile.domain.status === 'EXPIRED_EVAL'
			|| this.props.profile.domain.status === 'EXPIRED_PAID'
			|| this.props.profile.domain.status === 'UNINSTALLED_EVAL'
			|| this.props.profile.domain.status === 'INVITED_EXPIRED_EVAL'
			|| this.props.profile.domain.status === 'INVITED_EXPIRED_PAID'
			|| this.props.profile.domain.status === 'INVITED_UNINSTALLED_EVAL'
			|| this.props.profile.domain.status === 'INVITED_UNINSTALLED_EXPIRED'
			|| this.props.profile.domain.status === 'INVITED_UNINSTALLED_PAID'
		) {
			return (
				<>
					{
						this.props.isConfirmSwitchToFreePopupShown && <ConfirmSwitchToFreePopup/>
					}
					<TimedOutPage display={this.props.profile.domain.status}/>
				</>
			);
		} else {
			if(this.props.profile.accessStatus.isAdmin && this.props.profile.accessStatus.isContactsGranted === false){
				return (
					<GrantAccessTemplate/>
				)
			} else {
				return (
					<I18nextProvider i18n={i18n}>
						<div className='app'>
							<Header/>
							<Menu/>
							<GuidedToursListPopup/>
							{
								this.props.profile.domain.status === 'UNINSTALLED_PAID'
								&& !this.props.showSupportDetailsPopup
								&& <UninstalledPaidPopup/>
							}
							<SupportDetailsPopup/>
							{displayTutorial()}
							{
								this.props.videoPopup && <VideoPopup videoId={this.props.videoPopup}/>
							}
							{
								this.props.confirmFreeLicensesPopup && <ConfirmFreeLicensesPopup/>
							}
							{
								this.props.userUnShareErrorPopup && <FreeLicensesErrorPopup response={this.props.userUnShareErrorPopup}/>
							}
							{
								this.props.isUpgradeToBusinessPopup && <UpgradeToBusinessPopup/>
							}
							{
								this.props.isUserListAddCollaboratorsPopupShown && <UserListAddCollaboratorsPopup/>
							}
							{
								this.props.isOrgUnitAccessPopupShown && <OrgUnitAccessPopup/>
							}
							{
								this.props.isDirectoryV5AccessPopupShown && <DirectoryV5AccessPopup/>
							}
							{
								this.props.recordingConfirmPopupDisplay && <RecordingConfirmPopup mode={this.props.recordingConfirmPopupDisplay}/>
							}
							{
								this.props.isContactWithAiPopupShown && <ContactWithAiPopup action={this.props.isContactWithAiPopupShown.action} tab={this.props.isContactWithAiPopupShown.tab}/>
							}
							{
								this.props.isFreeEditionLabelContactLimitReachedPopupShown && <FreeEditionLabelContactLimitReachedPopup/>
							}
							<Content>
								{
									window.location.search.includes('?page=dashboard')
										?
										(
											<Dashboard/>
										)
										:
										window.location.search.includes('?page=api-key')
											?
											(
												<APIKey/>
											)
											: window.location.search.includes('?page=review-deleted-contacts')
											?
											(
												<ReviewDeletedContacts/>
											)
											:
											(
												<Switch>
													<Route exact path='/'>
														<Sharing/>
													</Route>
													<Route path='/label'>
														<Sharing/>
													</Route>
													<Route path='/contact'>
														<Sharing/>
													</Route>
													<Route path='/contacts/search'>
														<Sharing/>
													</Route>
													<Route exact path='/dashboard'>
														<Dashboard/>
													</Route>
													<Route
														exact
														path='/dashboard/users-list'
													>
														<Dashboard/>
													</Route>
													<Route
														exact
														path='/dashboard/custom-fields-manager'
													>
														<CustomFieldsManager/>
													</Route>
													<Route exact path='/my-profile'>
														<MyProfile/>
													</Route>
													<Route
														exact
														path='/dashboard/api-key'
													>
														<APIKey/>
													</Route>
													<Route
														exact
														path='/review-deleted-contacts'
													>
														<ReviewDeletedContacts/>
													</Route>
													<Route
														exact
														path='/support'
													>
														<Support/>
													</Route>
													<Redirect path='*' to={'/'} />
												</Switch>
											)
								}
							</Content>
						</div>
					</I18nextProvider>
				);
			}

		}
	}
}

const mapStateToProps = (state) => ({
	profile: state.profileReducer.getProfile,
	tutorialPopup: state.popupReducer.tutorialPopup,
	videoPopup: state.popupReducer.videoPopup,
	confirmFreeLicensesPopup: state.popupReducer.confirmFreeLicensesPopup,
	hasCollaboratorsPending: state.contactsGroupItemReducer.hasCollaboratorsPending,
	sharingDetailsPopup: state.sharingDetailsReducer.getSharingDetailsPopup,
	showSupportDetailsPopup: state.popupReducer.showSupportDetailsPopup,
	isUpgradeToBusinessPopup: state.popupReducer.isUpgradeToBusinessPopup,
	userUnShareErrorPopup: state.popupReducer.userUnShareErrorPopup,
	isUserListAddCollaboratorsPopupShown: state.popupReducer.isUserListAddCollaboratorsPopupShown,
	isContactWithAiPopupShown: state.popupReducer.isContactWithAiPopupShown,
	isOrgUnitAccessPopupShown: state.popupReducer.isOrgUnitAccessPopupShown,
	isDirectoryV5AccessPopupShown: state.popupReducer.isDirectoryV5AccessPopupShown,
	recordingConfirmPopupDisplay: state.popupReducer.recordingConfirmPopupDisplay,
	isConfirmSwitchToFreePopupShown: state.popupReducer.isConfirmSwitchToFreePopupShown,
	isFreeEditionLabelContactLimitReachedPopupShown: state.popupReducer.isFreeEditionLabelContactLimitReachedPopupShown
});

const mapDispatchToProps = (dispatch) => {
	return {
		setIsAnsweredChromeExtInstallRequest: (boolean) => {
			dispatch(isAnsweredChromeExtInstallRequest(boolean));
		},
		setSharingPageReady: (boolean) => {
			dispatch(sharingPageReady(boolean))
		},
		fetchCustomFields: () => {
			dispatch(fetchCustomFields())
		},
		fetchCustomFieldsForContactForm: () => {
			dispatch(fetchCustomFieldsForContactForm())
		},
	};
};

export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(RegisteredGrantedTemplate)
);
